import { getConfig } from "./localstorage"

export function convertLinkImg(url, baseUrl) {
  const config = getConfig("base_link")
  if (!url) return ""

  // Nếu BE trả về đường dẫn nội bộ kiểu `/media/...` thì render trực tiếp theo domain hiện tại.
  // Tránh fallback sang CDN mặc định gây lỗi `ERR_NAME_NOT_RESOLVED`.
  if (String(url).startsWith("/")) return url

  // URL full thì dùng luôn.
  if (String(url).includes("http")) return url

  // Nếu có cấu hình base URL (vd: image_url) thì ghép thêm.
  if (config && config.image_url) return String(config.image_url).replace(/\/$/, "") + "/" + String(url).replace(/^\//, "")
  if (baseUrl) return String(baseUrl).replace(/\/$/, "") + "/" + String(url).replace(/^\//, "")

  // Không có base nào thì trả nguyên chuỗi.
  return url
}
